import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout")({
    component: () => <AffiliateLayout />,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.report.affiliate.title"),
        asActive: true,
    }),
});

function AffiliateLayout() {
    return <Outlet />;
}
